import { KEEP_ALIVE_OBJECT } from '@/common/constants/ConstCode';
import store from '@/store';
import ServiceExec from '@/common/utils/ServiceExec';
import { config } from '@/common/service/apiList';

// 260626 마이노트(쉼) 원래 플로우 복원: 진입점 = /welldying/menu(웰다잉 선택) → 카드 → /welldying/my/:category.
// 화이트리스트(대표 형 + 와쳐 4명)만 진입 허용. 메뉴·직접URL 모두 차단하려고 menu·my 양쪽에 가드.
// 매 진입 fresh 조회(운영 토글 즉시 반영), 미허용/미로그인/오류는 fail-closed로 /main 리다이렉트.
const mynoteRestGuard = async (to, from, next) => {
  const { userNo } = store.getters['user/getUserData'] || {};
  if (!userNo) return next('/intro');
  try {
    const { data, status } = await ServiceExec.get(config.mynoteAccess);
    if (status === ServiceExec.status.OK && data && data.enabled) return next();
  } catch (_) {
    /* fail-closed */
  }
  return next('/intro');
};

export default [
  {
    path: '/welldying/menu',
    component: () => import('@/views/welldying/WellDyingMenu.vue'),
    beforeEnter: mynoteRestGuard,
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: '웰다잉 선택',
      expression: KEEP_ALIVE_OBJECT.WELL_DYING.expression
    }
  },

  {
    path: '/welldying/:category',
    component: () => import('@/views/welldying/WelldyingList.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: ''
      // expression: KEEP_ALIVE_OBJECT.WELL_DYING.expression
    }
  },

  {
    path: '/welldying/my/:category',
    component: () => import('@/views/welldying/MyWelldyingList.vue'),
    // 260626 마이노트(쉼) 화이트리스트 가드: menu에서 선택한 모든 카테고리 보호 + 직접URL 차단.
    beforeEnter: mynoteRestGuard,
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      isHome: true,
      titleName: ''
      // expression: KEEP_ALIVE_OBJECT.WELL_DYING.expression
    }
  },

  {
    path: '/welldying/form/:category',
    component: () => import('@/views/welldying/WelldyingList.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: '',
      subName: 'Well Dying'
      // expression: KEEP_ALIVE_OBJECT.WELL_DYING.expression
    }
  },

  {
    path: '/welldying',
    component: () => import('@/views/welldying/index.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: '',
      expression: KEEP_ALIVE_OBJECT.WELL_DYING.expression
    }
  },
  {
    path: '/welldying/:userNo',
    component: () => import('@/views/welldying/index.vue'),
    meta: {
      isHeader: true,
      isNav: true,
      isBack: true,
      titleName: '',
      subName: 'Well Dying',
      expression: KEEP_ALIVE_OBJECT.WELL_DYING.expression
    }
  },
  {
    path: '/welldying/detail/:category/:wellNo',
    component: () => import('@/views/welldying/detail.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      isLike: true,
      titleName: '',
      expression: KEEP_ALIVE_OBJECT.WELL_DYING.expression
    }
  },
  {
    path: '/welldying/form',
    component: () => import('@/views/welldying/form.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      isHome: true,
      titleName: '웰다잉 등록하기',
      expression: KEEP_ALIVE_OBJECT.WELL_DYING.expression
    }
  },
  {
    path: '/welldying/form/:category/:wellNo',
    component: () => import('@/views/welldying/form.vue'),
    meta: {
      isHeader: true,
      isBack: true,
      titleName: '웰다잉 수정하기',
      expression: KEEP_ALIVE_OBJECT.WELL_DYING.expression
    }
  }
];
